import { ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BlockTree, BObjectModel, BObjectSummary, BreadDik, GQueovalDik, ParamApplication, Person, QResult, QueovalDik, QueovalParam, TDOEvenement } from '../../../../../models';
import { CreationReservationModel, PlanningOnglet, ReservationPlanning } from '../../../../../models/formation/planning.model';
import { CoreService, HttpService, QueovalDateService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { StageService } from '../../services/stage-modal.service';
import { PlanningService } from '../planning.service';


/**
 * composant de création des réservations temporaires
 */
@Component({
  selector: 'q-planning-creation',
  templateUrl: './planning-creation.component.html',
  styleUrls: ['./planning-creation.component.css'],
})

export class PlanningCreationComponent implements OnInit {

  /** liste des boutons de modes de découpage */
  public DailyModeList: Array<{ Title: string, Value: string, Selected: boolean, CompatiblesModes: Array<string> }> =
    [
      { Title: 'Matin', Value: 'AM', Selected: true, CompatiblesModes: ['PM'] },
      { Title: 'Après-midi', Value: 'PM', Selected: true, CompatiblesModes: ['AM'] },
      { Title: 'Journée', Value: 'DAY', Selected: false, CompatiblesModes: [] },
      { Title: 'Intervalle', Value: 'RANGE', Selected: false, CompatiblesModes: [] }
    ];

  /** liste des boutons des jours de la semaine (pour découpage)*/
  public DaysList: Array<{ Title: string, Value: string, Selected: boolean }> =
    [
      { Title: 'Lu', Value: 'Lu', Selected: true },
      { Title: 'Ma', Value: 'Ma', Selected: true },
      { Title: 'Me', Value: 'Me', Selected: true },
      { Title: 'Je', Value: 'Je', Selected: true },
      { Title: 'Ve', Value: 'Ve', Selected: true },
      { Title: 'Sa', Value: 'Sa', Selected: true },
      { Title: 'Di', Value: 'Di', Selected: true },
    ];

  /** heure de début de matinée (pour les modes matin, journée, et intervalle */
  public AMFrom: string = '';
  /** heure de fin de matinée (pour le mode matin)*/
  public AMTo: string = '';
  /** intervalle d'heures entre AMFrom et AMTo*/
  public AMDuration: string = '';

  /** heure de début de l'après-midi (pour le mode Après-midi */
  public PMFrom: string = '';
  /** heure de fin de l'après-midi (pour les modes Après-midi, journée, et intervalle */
  public PMTo: string = '';
  /** intervalle d'heures entre PMFrom et PMTo*/
  public PMDuration: string = '';

  /** intervalle d'heures entre AMFrom et PMTo pour le mode journée*/
  public DayDuration: string;
  /** intervalle d'heures entre AMFrom et PMTo pour le mode intervalle*/
  public RangeDurationHour: number = 0;
  /** intervalle de minutes entre AMFrom et PMTo pour le mode intervalle*/
  public RangeDurationMin: string = "00";

  public IdLieu: string = '0';
  public IdBureau: string = '0';

  public objects: BlockTree;
  /** liste des formateurs sélectionnés*/
  public formateurs: Array<Person> = [];
  /** liste des formateurs liés au stage */
  public formateursSurStage: Array<string> = [];

  /** bo pour le q-bodisplay*/
  public boParam: QueovalParam = new QueovalParam();
  /** bo  tampon en cas de retour arrière sans sauvegarde des modifications lors de la modification du boParam*/
  public boModel: BObjectModel = new BObjectModel();
  /** déclanche la demande d'envoi du bo modifié*/
  public getBo: boolean = false;

  public isLoading: boolean = false;

  /** liste des propriétés qu'il n'est pas logique de modifier en masse telles que les propriétés calculées (dates de début/fin), des propriétés zoom ou google,... */
  public boPropsToRemove: Array<GQueovalDik<string, boolean>> = [
    new GQueovalDik<string, boolean>(TDOEvenement.Cols.datDebut.toLowerCase(), true),
    new GQueovalDik<string, boolean>(TDOEvenement.Cols.datFin.toLowerCase(), true),
    new GQueovalDik<string, boolean>(TDOEvenement.Cols.strUrlVideoZoom.toLowerCase(), true),
    new GQueovalDik<string, boolean>(TDOEvenement.Cols.strZoomUrl.toLowerCase(), true),
    new GQueovalDik<string, boolean>("typezeve", true),
    new GQueovalDik<string, boolean>("idgooeve", true),
    new GQueovalDik<string, boolean>("lstupeve", true)
  ];

  constructor(
    private modalService: NgbModal,
    private http: HttpService,
    private indParam: CoreService,
    public planningService: PlanningService,
    private toast: ToastService,
    private stageService: StageService,
    private cd: ChangeDetectorRef,
    protected queovalDateService: QueovalDateService,
  ) { }

  public ngOnInit(): void {
    this.http.getHttp<QResult<Array<string>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/GET_FORMATEURS_SUR_STAGE/${this.stageService.Stage.Ident}`).subscribe((data: QResult<Array<string>>) => {
      this.formateursSurStage = data.Value;
    });

    /** instancie le BO_RESERV sans les propriétés boPropsToRemove */
    this.boParam.params = [new BreadDik('isLoaded', true)];
    this.planningService.GetBoReservFiltered(this.boPropsToRemove).subscribe((data: BObjectModel) => {
      this.boParam.model = data;
      this.boModel = JSON.parse(JSON.stringify(data));
    });
    //#region récupération des paramètres application de date de debut/fin/pauses de travail
    const params: Array<ParamApplication> = new Array<ParamApplication>();
    params.push(new ParamApplication('TimeBeginWork', 'AGENDA'));
    params.push(new ParamApplication('TimeMiddleAM', 'AGENDA'));
    params.push(new ParamApplication('TimeMiddlePM', 'AGENDA'));
    params.push(new ParamApplication('TimeEndWork', 'AGENDA'));
    params.push(new ParamApplication('SaturdayWorkingDay', 'AGENDA'));
    params.push(new ParamApplication('sundayWorkingDay', 'AGENDA'));
    this.indParam.GetParamsApplication(params).subscribe(
      (result: Array<ParamApplication>) => {

        result.forEach((param: ParamApplication) => {
          switch (param.Code) {
            case 'TimeBeginWork':
              if (param.DblValue != null)
                this.AMFrom = `${param.DblValue > 9 ? "" + param.DblValue : "0" + param.DblValue}:${param.StrValue == null ? "00" : Number(param.StrValue) > 9 ? "" + param.StrValue : "0" + param.StrValue}`;
              break;
            case 'TimeMiddleAM':
              if (param.DblValue != null)
                this.AMTo = `${param.DblValue > 9 ? "" + param.DblValue : "0" + param.DblValue}:${param.StrValue == null ? "00" : Number(param.StrValue) > 9 ? "" + param.StrValue : "0" + param.StrValue}`;
              break;
            case 'TimeMiddlePM':
              if (param.DblValue != null)
                this.PMFrom = `${param.DblValue > 9 ? "" + param.DblValue : "0" + param.DblValue}:${param.StrValue == null ? "00" : Number(param.StrValue) > 9 ? "" + param.StrValue : "0" + param.StrValue}`;
              break;
            case 'TimeEndWork':
              if (param.DblValue != null)
                this.PMTo = `${param.DblValue > 9 ? "" + param.DblValue : "0" + param.DblValue}:${param.StrValue == null ? "00" : Number(param.StrValue) > 9 ? "" + param.StrValue : "0" + param.StrValue}`;
              break;
            case 'SaturdayWorkingDay':
              this.DaysList[5].Selected = param.StrValue == '1';
              break;
            case 'sundayWorkingDay':
              this.DaysList[6].Selected = param.StrValue == '1';
              break;
          }
        });

        this.http.getHttp<QResult<number>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/GET_DUREE_STAGE/${this.stageService.Stage.Ident}`).subscribe(
          (result: QResult<number>) => {
            const integer: number = Math.floor(result.Value) ?? 0;
            this.RangeDurationHour = integer;
            const mins: number = (result.Value - integer) * 60;
            this.RangeDurationMin = mins < 10 ? "0" + mins : `${mins}` ?? "00";
          })

        this.CalculDuree(this.AMFrom, this.AMTo, 'AM');
        this.CalculDuree(this.PMFrom, this.PMTo, 'PM');
        this.CalculDuree(this.AMFrom, this.PMTo, 'DAY');
      });
    //#endregion
    this.http.getHttp<QResult<BlockTree>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/GET_MATERIEL_TREE/0`).subscribe(
      (result: QResult<BlockTree>) => {
        this.objects = result.Value;
      })
  }

  /**
   * méthode de sélection/déselction des boutons de modes de découpage
   * @param clickedDailyMode bouton cliqué
   */
  public OnClickDailyMode(clickedDailyMode: { Title: string, Value: string, Selected: boolean, CompatiblesModes: Array<string> }): void {
    clickedDailyMode.Selected = !clickedDailyMode.Selected;
    //dé-sélectionne les modes incompatibles (ex intervalle incompatible avec Matin)
    this.DailyModeList.forEach(dailyMode => {
      if (dailyMode.Value != clickedDailyMode.Value && !clickedDailyMode.CompatiblesModes.includes(dailyMode.Value)) {
        dailyMode.Selected = false;
      }
    });
  }


  // Ouverture de la modal pour consulter/modifier le bo de l'effectif
  public open(Modal: any) {
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE': break;
        default:
          this.boParam.model = JSON.parse(JSON.stringify(this.boModel));
          break;
      }
    }).catch((result) => {
      switch (result) {
        case 'SAVE': break;
        default:
          this.boParam.model = JSON.parse(JSON.stringify(this.boModel));
          break;
      }
    });
  }

  public OnFormateurSelect(formateurs: Array<Person>): void {
    this.formateurs = formateurs;
  }

  /**
   * si modalBO est renseigné c'est que l'on a cliqué sur le bouton de sauvegarde, sinon on annule les modifications
   * @param pBoModel
   * @param modalBO
   */
  public OnGetBo(pBoModel: BObjectModel, modalBO: NgbModalRef | null = null): void {
   // this.getBo = false;
    this.boParam.model = pBoModel;
    this.boModel = JSON.parse(JSON.stringify(pBoModel));
    if (modalBO)
      modalBO.close('SAVE');
  }

  /** colore le bouton des objets en couleur q-main si il y a au moins 1 objet sélectionné */
  public AnyObjectSelected(): boolean {
    if (!this.objects || this.objects.Children.length == 0)
      return false;
    let result: boolean = false;
    for (let i: number = 0; i < this.objects.Children.length; i++) {
      if (this.objects.Children[i].Children.filter(object => object.IsChecked).length > 0) {
        result = true;
        break;
      }
    }
    return result;
  }

  /** @description check/uncheck item from objects
 * @return
 */
  public moveItem(itemGroup: BlockTree, item: BlockTree): void {
    item.IsChecked = !item.IsChecked;
    // Si on décoche 1 objet alors le groupe doit être décoché
    if (!item.IsChecked) {
      itemGroup.IsChecked = false;
    }
  }

  /** clic sur le bouton d'import depuis les réservations par bureau (bascule la vue entre Planning et ReservBureau */
  public OnImport(): void {
    if (this.planningService.View == PlanningOnglet.ReservBureau)
      this.planningService.View = PlanningOnglet.Planning;
    else
      this.planningService.View = PlanningOnglet.ReservBureau;
  }

  /** Création du découpage */
  public OnSave(): void {
    //#region bloque l'appel serveur si un appel est déjà en courrs
    if (this.isLoading) {
      this.toast.showAlertToast('un découpage est déjà en cours.');
      return;
    }
    //#endregion

    this.isLoading = true;
    //#region création du modèle
    const model: CreationReservationModel = new CreationReservationModel();
    model.DateDebut = this.planningService.DateDebut;
    model.DateFin = this.planningService.DateFin;
    //récupère les jours sélectionnés
    model.Days = this.DaysList.filter(day => day.Selected).map(day => day.Value);
    //récupère les modes sélectionnés
    model.Modes = this.DailyModeList.filter(day => day.Selected).map(day => day.Value);
    model.Formateurs = this.formateurs;

    // Modification des dates du filtre si les dates sont hors "créneau"
    if (this.queovalDateService.Compare(model.DateDebut, '<', this.planningService.Filter.DateFin)) {
      this.planningService.Filter.DateDebut = model.DateDebut;
    }
    if (this.queovalDateService.Compare(model.DateFin, '>', this.planningService.Filter.DateDebut)) {
      this.planningService.Filter.DateFin = model.DateFin;
    }

    //récupère le BO
    model.model = JSON.parse(JSON.stringify(this.boParam.model));
    //#region affiche les propriétés qui avaient été masquées de force
    this.boPropsToRemove.forEach((propToRemove: GQueovalDik<string, boolean>) => {
      const summaryToRemove: BObjectSummary | undefined = model.model.summary.find(props => propToRemove.Key.toLowerCase() == props.ColumnName.toLowerCase());
      if (summaryToRemove) {
        model.model.Body.SelectedGroupsList[summaryToRemove.IndexGroupsList].DataList[summaryToRemove.IndexDataList].Visible = propToRemove.Value;
        if (model.model.Body.SelectedGroupsList[summaryToRemove.IndexGroupsList].DataList.filter(data => data.MainElementList.filter(element => element.Visible).length > 0).length > 0) {
          model.model.Body.SelectedGroupsList[summaryToRemove.IndexGroupsList].visible = true;
        }
      }
    });
    //#endregion

    //récupère les heures et durées
    model.AMFrom = this.AMFrom;
    model.AMTo = this.AMTo;
    model.AMDuration = this.AMDuration;
    model.PMFrom = this.PMFrom;
    model.PMTo = this.PMTo;
    model.PMDuration = this.PMDuration;
    model.DayDuration = this.DayDuration;
    model.RangeDuration = `${(this.RangeDurationHour ?? '0')}:${(this.RangeDurationMin ?? '00')}`;

    model.ObjetReserves = this.objects;
    model.IdLieu = this.IdLieu;
    model.IdBureau = this.IdBureau;
    model.StageIdent = this.stageService.Stage.Ident;
    //#endregion

    //appel serveur
    this.http.postHttp<QResult<Array<ReservationPlanning>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/CREATE_RESERVS_ARRAY`, model).subscribe(
      (result: QResult<Array<ReservationPlanning>>) => {
        this.isLoading = false;
        const createdReservations = this.planningService.ListeReservations.filter(reservation => reservation.Ident && reservation.Ident != "0");
        this.planningService.ListeReservations = createdReservations.concat(result.Value);
        this.planningService.RefreshReserv();
      });
  }
  /**Vérifie que les éléments obligatoires soient renseignés pour dévérouiller le bouton de découpage */
  public CanSave(): boolean {
    let value: boolean = false;
    let DailyModeListOk: number = 0
    // compare les heures de début et de fin pour chaque mode de découpage
    // ok si le mode n'est pas sélectionné ou si la date de fin est suppérieure à la date de fin et si au moins 1 mode est sélectionné
    for (let i: number = 0; i < this.DailyModeList.length; i++) {
      if (this.DailyModeList[i].Selected) {
        value = true;
        switch (this.DailyModeList[i].Value) {
          case 'AM':
            if (this.CompareTimes(this.AMFrom, this.AMTo)) {
              DailyModeListOk++;
            }
            break;
          case 'PM':
            if (this.CompareTimes(this.PMFrom, this.PMTo)) {
              DailyModeListOk++;
            }
            break;
          case 'DAY':
          case 'RANGE':
            if (this.CompareTimes(this.AMFrom, this.PMTo)) {
              DailyModeListOk++;
            }
            break;
        }
      }
      else {
        DailyModeListOk++;
      }
    }
    if (!value || DailyModeListOk != 4)
      return false;

    return true;
  }
  /**
   * calcul les durées en convertissant le format hh:mm en deux entiers puis affecte selon le pRefMode à la bonne variable globale de durée
   * @param pTimeFrom heure de début de référence
   * @param pTimeTo heure de fin de référence
   * @param pRefMode AM PM ou DAY car pas de calcul auto pour RANGE
   */
  public CalculDuree(pTimeFrom: string, pTimeTo: string, pRefMode: string): void {

    //convertion de hh:mm en [number, number]
    const from: number[] = pTimeFrom.split(':').map((val: string) => Number(val));
    const to: number[] = pTimeTo.split(':').map((val: string) => Number(val));

    //si une date est erronée durée = ''
    if (from.length != 2 || to.length != 2) {
      if (pRefMode == 'AM')
        this.AMDuration = '';
      else if (pRefMode == 'PM')
        this.PMDuration = '';
      else if (pRefMode = 'DAY') {
        this.DayDuration = '';
      }
    }

    let hours: number = 0;
    let minutes: number = 0;

    //ne calcul pas si l'heure de fin est inférieur à l'heure de début
    if (to[0] < from[0])
      return;
    else {
      hours = to[0] - from[0];
    }

    //calcul les minutes 
    if (to[1] < from[1]) {
      hours--;
      minutes = 60 - (from[1] - to[1]);
    }
    else {
      minutes = to[1] - from[1];
    }

    // concaténation des heures(: number) et minutes(: number) pour formater la durée hh:mm
    const value: string = `${hours > 9 ? "" + hours : "0" + hours}:${minutes > 9 ? "" + minutes : "0" + minutes}`;
    //affectation de la durée calculée à la bonne variable globale de durée
    if (pRefMode == 'AM')
      this.AMDuration = value;
    else if (pRefMode == 'PM')
      this.PMDuration = value;
    else if (pRefMode = 'DAY') {
      this.DayDuration = value;
    }
  }

  /**
   * vérifie que les minutes saisies sur l'input range soient inférieurs à 59
   * @param value minutes
   */
  public OnBlurRangeDurationMin(value: string): void {
    const mins: number = Number(value);
    if (isNaN(mins)) {
      const val = JSON.parse(JSON.stringify(this.RangeDurationMin));
      this.RangeDurationMin = "";
      this.cd.detectChanges();
      this.RangeDurationMin = val;
      return;
    }
      this.RangeDurationMin = mins > 59 ? "59" : mins < 10 ? "0" + mins : `${mins}` ?? "00";
  }

  /**
   * calcul les minutes de l'input range lorsque la valeur saisie change.
   * vérifie que seul un nombre soit saisi et formate la valeur de la même manière que le fait un input type="number"
   * @param value minutes
   */
  public OnRangeDurationMinChange(value: number): void {
    const mins: number = value % 100;
    if (isNaN(mins)) {
      const val = JSON.parse(JSON.stringify(this.RangeDurationMin));
      this.RangeDurationMin = "";
      this.cd.detectChanges();
      this.RangeDurationMin = val;
      return;
    }
      this.RangeDurationMin = mins < 10 ? "0" + mins : `${mins}` ?? "00";
  }

  /**
   * Fonction permettant de récupérer 1 seule fois le modèle du BO
   * Remise du getBo à false pour la prochaine récupération (à l'ouverture de la modale)
   * A voir s'il y a mieux que le settimeout...
   **/
  public setBo(): void {
    this.getBo = true;
    setTimeout(() => { this.getBo = false; },1)
  }

  /**
   * compare deux heures au format h:mm
   * @param pFrom
   * @param pTo
   */
  private CompareTimes(pFrom: string, pTo: string): boolean {
    const from: number[] = pFrom.split(':').map((val: string) => Number(val));
    const to: number[] = pTo.split(':').map((val: string) => Number(val));
    if (from.length != 2 || to.length != 2)
      return false;
    if (from[0] < to[0])
      return true;
    if (from[0] > to[0])
      return false;
    if (from[1] < to[1])
      return true;
    return false;
  }

}
